import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useSharedApps from '../../../utils/sitecoreContext/useSharedApps';
import { BUILD_AND_PRICE_URL } from '../../../utils/constants';
import { useSaveBuildUnsavedChanges } from '../../../core/apiHooks/useSaveBuild';
var ConfirmationModalType;
(function (ConfirmationModalType) {
    ConfirmationModalType["LEAVE_MODAL"] = "leave_modal";
    ConfirmationModalType["SAVE_BUILD_MODAL"] = "save_build_modal";
})(ConfirmationModalType || (ConfirmationModalType = {}));
function useBapNavigationBlock(canAllowNavigation) {
    const history = useHistory();
    const location = useLocation();
    const [nextUrl, setNextUrl] = useState('');
    const [confirmationModal, setConfirmationModal] = useState(null);
    const bapBaseUrl = useSharedApps(BUILD_AND_PRICE_URL);
    const { hasUnsavedChanges, canUpdateBuild, userHasUpdatedBuild } = useSaveBuildUnsavedChanges();
    const userIsOnBap = location.pathname.includes(bapBaseUrl);
    useEffect(() => {
        const unblock = history.block(url => {
            function showConfirmation() {
                setNextUrl(`${url.pathname}${url.search || ''}${url.hash || ''}`);
                if (canUpdateBuild) {
                    setConfirmationModal(ConfirmationModalType.LEAVE_MODAL);
                }
                else {
                    setConfirmationModal(ConfirmationModalType.SAVE_BUILD_MODAL);
                }
            }
            const shouldAllowNavigation = url.pathname.includes(bapBaseUrl) || !canAllowNavigation;
            if (shouldAllowNavigation)
                return;
            if (canUpdateBuild) {
                if (!hasUnsavedChanges && userHasUpdatedBuild)
                    return; // allow navigation
                showConfirmation();
                return false;
            }
            showConfirmation();
            return false;
        });
        return unblock;
    }, [
        history,
        userIsOnBap,
        canUpdateBuild,
        userHasUpdatedBuild,
        hasUnsavedChanges,
        canAllowNavigation,
        bapBaseUrl,
        location,
    ]);
    return {
        nextUrl,
        showLeaveModal: confirmationModal === ConfirmationModalType.LEAVE_MODAL,
        showSaveBuildModal: confirmationModal === ConfirmationModalType.SAVE_BUILD_MODAL,
        closeModal() {
            setConfirmationModal(null);
        },
    };
}
export default useBapNavigationBlock;
